import { FeatureBlock } from '@af/design-system-docs-ui/feature-block';
import { FeatureBlockGrid } from '@af/design-system-docs-ui/feature-block-grid';
import { principles } from "../../../../src/pages/rovo-ui/about-rovo-ui/_content/_principles";
import recognisableDark from "../../../../src/pages/rovo-ui/about-rovo-ui/_assets/recognisable-dark.png";
import recognisableLight from "../../../../src/pages/rovo-ui/about-rovo-ui/_assets/recognisable-light.png";
import rovoDialectDiagramDark from "../../../../src/pages/rovo-ui/about-rovo-ui/_assets/rovo-dialect-diagram-dark.png";
import rovoDialectDiagramLight from "../../../../src/pages/rovo-ui/about-rovo-ui/_assets/rovo-dialect-diagram-light.png";
import * as React from 'react';
export default {
  FeatureBlock,
  FeatureBlockGrid,
  principles,
  recognisableDark,
  recognisableLight,
  rovoDialectDiagramDark,
  rovoDialectDiagramLight,
  React
};